// Central config — kontaktné údaje sú placeholder, doplnia sa reálne hodnoty.
// Official brand assets (designer files — used unmodified).
// LOGO_URL: full horizontal logotype (icon + "Sedlo Services" text).
// LOGO_ICON: standalone square "S" icon mark (used for watermark / favicon).
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_sedlo-repair/artifacts/jn62kb6h_21.png";
export const LOGO_ICON =
  "https://customer-assets.emergentagent.com/job_sedlo-repair/artifacts/z1s71ug8_31.png";

export const CONTACT = {
  phone: "+421 948 272 422",
  phoneHref: "tel:+421948272422",
  whatsapp: "421948272422",
  whatsappHref: "https://wa.me/421948272422",
  email: "info@sedloservices.sk",
  addressLine1: "Martinská 1619/7",
  addressLine2: "010 08 Žilina, Slovensko",
  hoursNote: "Individuálne podľa dohody a povahy zákazky.",
  mapsQuery: "Martinská 1619/7, 010 08 Žilina",
  directionsHref: "https://www.google.com/maps/dir/?api=1&destination=" + encodeURIComponent("Martinská 1619/7, 010 08 Žilina, Slovensko"),
};

export const SOCIALS = [
  { name: "Facebook", href: "https://www.facebook.com/p/Servis-Elektroniky-%C5%BDilina-Sedlo-Services-100086986592284/", icon: "facebook" },
  { name: "Instagram", href: "https://www.instagram.com/sedlo_services/", icon: "instagram" },
  { name: "YouTube", href: "https://www.youtube.com/@sedlo_services", icon: "youtube" },
  { name: "TikTok", href: "https://www.tiktok.com/@sedlo_services", icon: "tiktok" },
  { name: "WhatsApp", href: "https://wa.me/421948272422", icon: "whatsapp" },
];

export const GOOGLE_REVIEWS_URL = "https://www.google.com/search?q=Sedlo+Services+Žilina";

// Production domain — used for canonical & hreflang SEO tags (site is served here in prod).
export const SITE_ORIGIN = "https://sedloservices.sk";

export const SERVICES = [
  { title: "Servis elektroniky", desc: "Diagnostika a oprava spotrebnej aj profesionálnej elektroniky.", icon: "cpu" },
  { title: "Opravy notebookov a počítačov", desc: "Hardvér, chladenie, čistenie a obnova dát.", icon: "laptop" },
  { title: "Domáca a priemyselná elektronika", desc: "Servis riadiacich jednotiek, spotrebičov a priemyselných zariadení.", icon: "factory" },
  { title: "Elektroinštalácie", desc: "Návrh, montáž a opravy elektroinštalácií a rozvádzačov.", icon: "zap" },
  { title: "Fotovoltika", desc: "Návrh a technická podpora fotovoltaických systémov.", icon: "sun" },
  { title: "Kamerové systémy", desc: "Inštalácia a servis kamerových a bezpečnostných systémov.", icon: "cctv" },
  { title: "Špeciálne elektro riešenia na mieru", desc: "Zákazkové technické riešenia podľa potrieb zákazníka.", icon: "wrench" },
  { title: "Poradenstvo v elektrotechnike", desc: "Odborné poradenstvo pri návrhu a riešení zapojení.", icon: "clipboard-list" },
  { title: "Tvorba webových stránok", desc: "Návrh, tvorba a správa moderných webových stránok a online prezentácií.", icon: "globe" },
];

export const SERVICE_TYPES = SERVICES.map((s) => s.title);

const wq = "crop=entropy&cs=srgb&fm=webp&q=80&w=1200";
const wqp = "auto=compress&cs=tinysrgb&dpr=2&w=1200";

export const GALLERY = [
  { src: `https://images.unsplash.com/photo-1517055729445-fa7d27394b48?${wq}`, alt: "Detail dosky plošných spojov" },
  { src: `https://images.unsplash.com/photo-1562568068-7a90cf9e499d?${wq}`, alt: "Spájkovanie pri oprave" },
  { src: `https://images.unsplash.com/photo-1588515603140-81bd9f7d1db0?${wq}`, alt: "Oprava notebooku" },
  { src: `https://images.unsplash.com/photo-1660330589257-813305a4a383?${wq}`, alt: "Montáž fotovoltiky na streche" },
  { src: `https://images.unsplash.com/photo-1544724569-5f546fd6f2b5?${wq}`, alt: "Elektroinštalácia a rozvádzač" },
  { src: `https://images.unsplash.com/photo-1589935447067-5531094415d1?${wq}`, alt: "Inštalácia kamerového systému" },
  { src: `https://images.unsplash.com/photo-1526392269816-39d8ed656494?${wq}`, alt: "Doska plošných spojov" },
  { src: `https://images.unsplash.com/photo-1611396000732-f8c9a933424f?${wq}`, alt: "Priemyselná elektronika" },
  { src: `https://images.unsplash.com/flagged/photo-1566838616631-f2618f74a6a2?${wq}`, alt: "Fotovoltaické panely na dome" },
  { src: `https://images.unsplash.com/photo-1758101755915-462eddc23f57?${wq}`, alt: "Meranie elektrického rozvádzača" },
  { src: `https://images.unsplash.com/photo-1618482914248-29272d021005?${wq}`, alt: "Bezpečnostné kamery" },
  { src: `https://images.unsplash.com/photo-1555589228-135c25ae8cf5?${wq}`, alt: "Mikroskopická oprava elektroniky" },
  { src: `https://images.unsplash.com/photo-1635335874521-7987db781153?${wq}`, alt: "Zapojenie rozvodnej skrine" },
  { src: `https://images.unsplash.com/photo-1655300256335-beef51a914fe?${wq}`, alt: "Fotovoltika na rodinnom dome" },
];

export const REVIEWS = [
  { name: "Martin K.", rating: 5, text: "Rýchla oprava telefónu, profesionálny prístup. Odporúčam!", date: "pred 2 týždňami" },
  { name: "Jana P.", rating: 5, text: "Notebook ako nový. Skvelá komunikácia a férová cena.", date: "pred mesiacom" },
  { name: "Peter H.", rating: 5, text: "Pomohli s priemyselnou elektronikou, keď to iní vzdali.", date: "pred mesiacom" },
  { name: "Lucia M.", rating: 4, text: "Spoľahlivý servis, všetko vysvetlili zrozumiteľne.", date: "pred 2 mesiacmi" },
];

export const RATING = { avg: 4.9, count: 128 };
